module.exports = __webpack_public_path__ + "img/logo.b208f8d7.png";